<script setup lang="ts">
  import { type IconName, IconSizeMap } from '@/types';
  import { computed } from 'vue';

  const { size = 'default' } = defineProps<{
    icon: IconName;
    size?: keyof typeof IconSizeMap;
  }>();

  const mappedSize = computed<string>(() => IconSizeMap[size || 'default']);
</script>

<template>
  <svg
    role="img"
    class="svg-icon h-auto cursor-[inherit] align-middle"
    :style="`font-size: ${mappedSize}`"
    width="1em"
    height="1em"
    aria-hidden="true"
  >
    <use :href="`#icon-${icon}`" />
  </svg>
</template>
